module.exports = __webpack_public_path__ + "img/cash-report.6eec9a0b.png";